import fetch from '@/utils/fetch';
import {systemFetch} from '@/utils/fetch';

// 获得审批人负责的分组列表
export function getUserExamineGroupList(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/getUserExamineGroupList',
        method: 'post',
        data: params
    });
}

// 获得报名学生详细信息
export function getStuDetailById(args) {
    let params = new URLSearchParams();
    params.append('stuId', args.stuId);

    return fetch({
        url: 'structure/staterunEnrol/getStuDetailById',
        method: 'post',
        data: params
    });
}


// 获得群组下报名学生列表

export function getGroupApplyStuPageList(args) {
    let params = new URLSearchParams();
    params.append('groupId', args.groupId);
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('searchVal', args.searchVal);
    params.append('state', args.state);
    params.append('homeAddress', args.homeAddress);

    return fetch({
        url: 'structure/staterunEnrol/getGroupApplyStuPageList',
        method: 'post',
        data: params
    });
}

// 获取通知列表不分页

export function getSchoolEnrolNoticeList(args) {
    let params = new URLSearchParams();
    params.append('searchVal', args.searchVal);
    params.append('state', args.state);

    return fetch({
        url: 'structure/staterunEnrol/getSchoolEnrolNoticeList',
        method: 'post',
        data: params
    });
}

// 获得通知下的所有分组列表
export function getNoticeGroupList(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/getNoticeGroupList',
        method: 'post',
        data: params
    });
}

// 根据当前年份year和schoolId 获取字段设置信息
export function getFieldSetInfo(args) {
    let params = new URLSearchParams();
    params.append('schoolId', args.schoolId);
    params.append('yearNo', args.yearNo);

    return fetch({
        url: 'common/staterunEnrolStudent/getFieldSetInfo',
        method: 'post',
        data: params
    });
}

// 获得学生审批意见列表
export function getStuExamineInfoList(args) {
    let params = new URLSearchParams();
    params.append('recStuId', args.recStuId);

    return fetch({
        url: 'structure/staterunEnrol/getStuExamineInfoList',
        method: 'post',
        data: params
    });
}

// 审批员审批上报学生信息
export function examineApplyStu(args) {
    let params = new URLSearchParams();
    params.append('examineCode', args.examineCode);
    params.append('examinePicJson', '{}');
    params.append('examineRemark', args.examineRemark);
    params.append('examineValue', args.examineValue);
    params.append('groupId', args.groupId);
    params.append('recStuId', args.recStuId);
    params.append('status', args.status);

    return fetch({
        url: 'structure/staterunEnrol/examineApplyStu',
        method: 'post',
        data: params
    });
}

// 根据条件查询上报学生列表(最新通知下)
export function getStuListByCondition(args) {
    let params = new URLSearchParams();
    params.append('searchVal', args.searchVal);
    params.append('noticeId', args.noticeId);
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);

    return fetch({
        url: 'structure/staterunEnrol/getStuListByCondition',
        method: 'post',
        data: params
    });
}

/*获得学校当前年份上报字段列表*/
export function getSchoolEnrolFieldList(args) {
    let params = new URLSearchParams();
    params.append('yearNo', args.yearNo);

    return fetch({
        url: 'structure/staterunEnrol/getSchoolEnrolFieldList',
        method: 'post',
        data: params
    });
}

/*学生信息终审*/
export function finalExamineStudent(args) {
    let params = new URLSearchParams();
    params.append('finalState', args.finalState);
    params.append('id', args.id);
    params.append('isProperty', args.isProperty);
    params.append('isRealLive', args.isRealLive);
    params.append('isTeachArea', args.isTeachArea);
    params.append('isTeachAreaNotice', args.isTeachAreaNotice);
    params.append('isVisit', args.isVisit);
    params.append('isLocalRegister', args.isLocalRegister);
    params.append('examineRemark', args.examineRemark);

    return fetch({
        url: 'structure/staterunEnrol/finalExamineStudent',
        method: 'post',
        data: params
    });
}

// 获得审批人负责的通知列表
export function getExamineNoticeList() {

    return fetch({
        url: 'structure/staterunEnrol/getExamineNoticeList',
        method: 'post',
    });
}



// 录取
export function admitStu(args) {
    const params = new URLSearchParams();

    params.append('stuIds', args.stuIds);
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/admitStu',
        method: 'post',
        timeout: 300000,
        data: params
    });
}
// 预录取
export function preAdmitStu(args) {
    const params = new URLSearchParams();

    params.append('stuIds', args.stuIds);
    params.append('noticeId', args.noticeId);

    return fetch({
        url: 'structure/staterunEnrol/preAdmitStu',
        method: 'post',
        data: params
    });
}

// 线下一审
export function offlineFirstExamineStudent(args) {
    const params = new URLSearchParams();

    params.append('recStuId', args.recStuId);
    params.append('examineRemark', args.examineRemark);
    params.append('status', args.status);
    params.append('offlinePendIds', args.offlinePendIds);
    params.append('offlinePends', args.offlinePends);

    return fetch({
        url: 'structure/staterunEnrol/offlineFirstExamineStudent',
        method: 'post',
        data: params
    });
}
// 查询学生线下一审记录
export function getStuOfflineOneExamineRecordList(stuId) {
    const params = new URLSearchParams();
    params.append('stuId', stuId);
    return fetch({
        url: 'structure/staterunEnrol/getStuOfflineOneExamineRecordList',
        method: 'post',
        data: params
    });
}
// 查询学生线下二审记
// // 查询学位被占用的学生列表（分页）录
export function getStuOfflineTwoExamineRecordList (stuId) {
    const params = new URLSearchParams();
    params.append('stuId', stuId);
    return fetch({
        url: 'structure/staterunEnrol/getStuOfflineTwoExamineRecordList',
        method: 'post',
        data: params
    });
}

// 新增学生备注
export function addStuRemarkRecord(args) {
    const params = new URLSearchParams();
    params.append('noticeId', args.noticeId);
    params.append('remark', args.remark);
    params.append('stuId', args.stuId);

    return fetch({
        url: 'structure/staterunEnrol/addStuRemarkRecord',
        method: 'post',
        data: params
    });
}

// 根据ID删除学生备注
export function delStuRemarkById(args) {
    const params = new URLSearchParams();
    params.append('stuRemarkId', args.stuRemarkId);

    return fetch({
        url: 'structure/staterunEnrol/delStuRemarkById',
        method: 'post',
        data: params
    });
}

// 根据学生ID获得学生备注列表
export function getStuRemarkRecordList(args) {
    const params = new URLSearchParams();
    params.append('stuId', args.stuId);

    return fetch({
        url: 'structure/staterunEnrol/getStuRemarkRecordList',
        method: 'post',
        data: params
    });
}

/*获得报名通知下的所有报名学生列表*/
export function getNoticeApplyStuPageList(args = {}) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);
    params.append('searchVal', args.searchVal);
    params.append('state', args.state);
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);

    return fetch({
        url: 'structure/staterunEnrol/getNoticeApplyStuPageList',
        method: 'post',
        data: params
    });
}

//
export function getStuLiveRemarkRecordList(args) {
    let params = new URLSearchParams();
    params.append('stuId', args.stuId);

    return fetch({
        url: 'structure/staterunEnrol/getStuLiveRemarkRecordList',
        method: 'post',
        data: params
    });
}

// 查询学位被占用的学生列表（分页）
export function getNoticeDegreeOccupyStuPageList(args) {
    let params = new URLSearchParams();
    params.append('noticeId', args.noticeId);
    params.append('pageNo', args.pageNo);
    params.append('pageSize', args.pageSize);
    params.append('searchTitle', args.searchTitle);

    return fetch({
        url: 'structure/staterunEnrol/getNoticeDegreeOccupyStuPageList',
        method: 'post',
        data: params
    });
}
//
export function updateStuNameById(args) {
    let params = new URLSearchParams();
    params.append('id', args.id);
    params.append('stuName', args.stuName);

    return fetch({
        url: 'structure/staterunEnrol/updateStuNameById',
        method: 'post',
        data: params
    });
}



// WEBPACK FOOTER //
// ./src/api/primary/review.js